"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasToken = exports.auth = exports.checkAuth = exports.refreshToken = exports.dropAuthentication = exports.authenticate = void 0;
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const dex_guru_fetch_1 = require("@telekomconsalting/dex-guru-fetch");
const apiAuthAdapter_1 = require("../adapters/apiAuthAdapter");
const web3Adapter_1 = require("../adapters/web3Adapter");
var LocalStorageKeyEnum;
(function (LocalStorageKeyEnum) {
    LocalStorageKeyEnum["account_id"] = "accountId";
    LocalStorageKeyEnum["access_token"] = "accessToken";
    LocalStorageKeyEnum["refresh_token"] = "refreshToken";
})(LocalStorageKeyEnum || (LocalStorageKeyEnum = {}));
const setLocalStorageItems = (items) => {
    const _items = Object.entries(items).map((item) => {
        const key = item[0];
        const value = item[1] || '';
        return [LocalStorageKeyEnum[key], value];
    });
    _items.forEach((item) => {
        localStorage.setItem(...item);
    });
};
const checkAndStoreTokens = (response) => {
    if (response.access_token && response.access_token !== 'undefined') {
        localStorage.setItem(LocalStorageKeyEnum.access_token, response.access_token);
        if (response.refresh_token && response.refresh_token !== 'undefined') {
            localStorage.setItem(LocalStorageKeyEnum.refresh_token, response.refresh_token);
        }
        return {
            error: null,
            accessToken: response.access_token,
            refreshToken: response.refresh_token || localStorage.getItem(LocalStorageKeyEnum.refresh_token),
        };
    }
    return { error: null, accessToken: null, refreshToken: null };
};
const authenticate = (instance, wallet, accountId, library) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield apiAuthAdapter_1.loginRequest(instance, wallet, accountId);
        const authResponse = checkAndStoreTokens(response);
        if (authResponse.accessToken) {
            return authResponse;
        }
        let signature = '';
        if (!response.access_token && response.nonce && wallet) {
            signature = yield web3Adapter_1.web3Sign(response.nonce, wallet, library);
            const { access_token, refresh_token, account_id } = yield apiAuthAdapter_1.loginRequest(instance, wallet, accountId, response.nonce, signature);
            setLocalStorageItems({ access_token, refresh_token, account_id });
            return { error: null, accessToken: access_token, refreshToken: refresh_token };
        }
        return { error: null, accessToken: null, refreshToken: null };
    }
    catch (error) {
        return { error, accessToken: null, refreshToken: null };
    }
});
exports.authenticate = authenticate;
const dropAuthentication = (instance) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const accessToken = localStorage.getItem(LocalStorageKeyEnum.access_token);
        if (accessToken) {
            yield dex_guru_fetch_1.apiFetch(instance, `/auth/access-revoke`, {
                init: { method: 'DELETE' },
                onError: (error) => {
                    throw error;
                },
            });
        }
        localStorage.setItem(LocalStorageKeyEnum.access_token, '');
        localStorage.setItem(LocalStorageKeyEnum.refresh_token, '');
        return { error: null };
    }
    catch (error) {
        return { error };
    }
});
exports.dropAuthentication = dropAuthentication;
const refreshToken = (instance) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const refreshToken = localStorage.getItem(LocalStorageKeyEnum.refresh_token) || '';
        const response = yield apiAuthAdapter_1.refreshRequest(instance, refreshToken);
        return checkAndStoreTokens(response);
    }
    catch (error) {
        return { error, accessToken: null, refreshToken: null };
    }
});
exports.refreshToken = refreshToken;
const checkAuth = (instance, wallet, library, onSuccess, onFail) => __awaiter(void 0, void 0, void 0, function* () {
    if (!wallet) {
        localStorage.removeItem('walletId');
        return;
    }
    if (wallet) {
        const walletId = localStorage.getItem('walletId');
        if (walletId && walletId !== wallet) {
            localStorage.setItem('accessToken', '');
            onFail && onFail();
        }
        const { isAuth } = yield exports.auth(instance, wallet, library);
        if (!isAuth) {
            onFail && onFail();
        }
        else {
            onSuccess && onSuccess();
            localStorage.setItem('walletId', wallet);
        }
    }
});
exports.checkAuth = checkAuth;
const auth = (instance, wallet, library) => __awaiter(void 0, void 0, void 0, function* () {
    let accessToken = localStorage.getItem(LocalStorageKeyEnum.access_token);
    const accountId = localStorage.getItem(LocalStorageKeyEnum.account_id) || '';
    if (accessToken) {
        const decoded = jsonwebtoken_1.default.decode(accessToken);
        const now = new Date().valueOf();
        const exp = (decoded === null || decoded === void 0 ? void 0 : decoded.exp) || 0;
        if (exp * 1000 > now) {
            return { isAuth: true, error: null };
        }
        localStorage.setItem(LocalStorageKeyEnum.access_token, '');
        accessToken = null;
    }
    if (!accessToken && wallet) {
        const { error, accessToken } = yield exports.authenticate(instance, wallet, accountId, library);
        if (error) {
            return { isAuth: false, error };
        }
        if (accessToken) {
            return { isAuth: true, error };
        }
    }
    return { isAuth: false, error: null };
});
exports.auth = auth;
const hasToken = () => !!localStorage.getItem(LocalStorageKeyEnum.access_token);
exports.hasToken = hasToken;
//# sourceMappingURL=authService.js.map